import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthProvider';
import { Result, Button } from 'antd';

const TenantRoute = ({ children, allowedTenants }) => {
  const { currentUser, tenantType } = useAuth();
  
  // If user is not authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  // If no tenant type is set, redirect to login
  if (!tenantType) {
    return <Navigate to="/login" />;
  }
  
  // Check if current tenant is allowed
  if (!allowedTenants.includes(tenantType)) {
    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle={`Sorry, you don't have permission to access this page. This page is only available for ${allowedTenants.join(', ')} users.`}
        extra={
          <Button type="primary" onClick={() => window.history.back()}>
            Go Back
          </Button>
        }
      />
    );
  }
  
  return children;
};

export default TenantRoute; 